export default __webpack_public_path__ + "static/media/peintures.a252fc96.jpeg";